import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'sp-copy-set-snackbar-message',
    templateUrl: './copy-set-snackbar-message.component.html',
    styleUrls: ['./copy-set-snackbar-message.component.scss'],
})
export class CopySetSnackbarMessageComponent implements OnInit {
    constructor(
        public snackBarRef: MatSnackBarRef<CopySetSnackbarMessageComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data:any
    ) {}

    ngOnInit(): void {}
}
